// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import {useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
// @ts-ignore
import cookie from 'cookie';
import etask from 'zetask';
import config from 'pub_config';
import {use_qs} from '../lib/use_qs';
import uutil from '/www/hola/pub/unblock_util.js';
import {sitepic_activate} from './sitepic_activate.js';
import {start_install} from './install_util.js';
// @ts-ignore
import {fetch} from '/util/fetch.js';

const global_search_tasks = {};

interface i_use_search_props extends object_of<any> {
    top_unblocked?: boolean;
    categories?: string[];
    page?: string;
}

const get_sorted = (rules, categories)=>{
    if (categories && categories.length>0)
    {
        rules = [...rules].sort((r1, r2)=>{
            const p1 = categories.indexOf(r1.category);
            const p2 = categories.indexOf(r2.category);
            if (p1===-1 && p2===-1)
                return 0;
            if (p1===-1)
                return 1;
            if (p2===-1)
                return -1;
            return 0;
        });
    }
    return rules;
};

export const use_search = (props: i_use_search_props)=>{
    const [rule_ratings, set_rules] = useState(get_sorted(
        props.rule_ratings||[], props.categories));
    const [top_unblocked, set_top_unblocked] = useState(null);
    const [filter, set_filter] = useState('');
    const [focused, set_focused] = useState(false);
    const [busy, set_busy] = useState(false);
    const [active, set_active] = useState(null);
    const [sitepics, set_sitepics] = useState({matches: rule_ratings,
        google: false, is_generic: false});
    const [adult_content, set_adult_content_] =
        useState(cookie.get && cookie.get('adult_content') || false);
    const [adult_changed, set_adult_changed] = useState(false);
    const [refresh, set_refresh] = useState(1);
    const set_adult_content = value=>{
        set_adult_content_(value);
        set_adult_changed(true);
    };
    const {pathname} = useLocation();
    const qs = use_qs();
    const ref_categories = useRef(props.categories);
    const set_rule_ratings = rules=>{
        set_rules(get_sorted(rules, ref_categories.current));
    };
    useEffect(()=>{
        ref_categories.current = props.categories;
        set_rule_ratings(rule_ratings);
    }, [JSON.stringify(props.categories)]);
    useEffect(()=>{
        if (!qs.embed_hola_browser && pathname.indexOf('/vpn_config')==0)
            return;
        if (global_search_tasks[`ad_${adult_content}`])
        {
            let et_wait = etask(function*(){
                let rules = yield global_search_tasks[`ad_${adult_content}`];
                global_search_tasks[`ad_${adult_content}`] = undefined;
                if (!rules)
                    set_refresh(r=>r+1);
                else
                    set_rule_ratings(rules);
            });
            return ()=>et_wait.return();
        }
        let et = etask(function*(){
            let search_p: object_of<any> = {format_rules: true,
                country: props.country_code};
            if (adult_content)
                search_p.adult_content = 1;
            let rules = yield fetch(
                `${config.backend_url}/access/popular.json?${new
                    URLSearchParams(search_p)}&cached=1`);
            global_search_tasks[`ad_${adult_content}`] = undefined;
            set_rule_ratings(rules);
            if (props.top_unblocked)
            {
                let top = yield fetch(
                    `${config.backend_url}/access/top_unblocked.json?${new
                        URLSearchParams(search_p)}&cached=1`);
                set_top_unblocked(top);
            }
            return rules;
        });
        global_search_tasks[`ad_${adult_content}`] = et;
        return ()=>{
          global_search_tasks[`ad_${adult_content}`] = undefined;
          et.return();
        };
    }, [props.rule_ratings, adult_content, adult_changed, refresh]);
    useEffect(()=>{
        set_sitepics(uutil.find_matches(rule_ratings || [], filter,
            {country: props.user_country, domains: top_unblocked}));
    }, [filter, props.user_country, rule_ratings]);
    const on_change_filter = event=>{
        if (busy)
            return;
        set_filter(event.target.value||'');
    };
    const activate = (event, rate)=>{
        const opt = {
            need_exe: props.need_exe,
            deactivate: ()=>{
                set_active(null);
                set_busy(false);
            },
            start_install,
            filter,
            page: props.page
        };
        set_active(rate);
        set_busy(true);
        sitepic_activate(event, rate, opt);
    };
    const on_clear = ()=>set_filter('');
    return {filter, on_change_filter, sitepics, busy, activate, set_busy,
        on_clear, active, focused, set_focused, set_adult_content,
        rule_ratings, set_active};
};
